import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, unref as _unref, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "footer-component" }
const _hoisted_2 = { class: "footer-content-width footer-sections" }
const _hoisted_3 = { class: "left-part-element" }
const _hoisted_4 = {
  class: "left-aligned-text text-style-1",
  style: {"white-space":"break-spaces"}
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "follow-links"
}
const _hoisted_7 = { class: "follow-header" }
const _hoisted_8 = { class: "follow-icons" }
const _hoisted_9 = ["aria-label", "href"]
const _hoisted_10 = { class: "navigation-part" }
const _hoisted_11 = { class: "navigation-items" }
const _hoisted_12 = {
  key: 0,
  class: "navigation-header"
}
const _hoisted_13 = ["href", "target"]
const _hoisted_14 = {
  key: 0,
  class: "formula-error-row"
}
const _hoisted_15 = ["disable"]
const _hoisted_16 = { class: "formula-block" }
const _hoisted_17 = { class: "formula-header" }
const _hoisted_18 = { class: "formula-subtext" }
const _hoisted_19 = { class: "left-aligned-text text-style-1" }
const _hoisted_20 = { class: "formula-row" }
const _hoisted_21 = { class: "formula-col" }
const _hoisted_22 = {
  key: 0,
  class: "formula-error-row"
}
const _hoisted_23 = {
  key: 1,
  class: "formula-field-header"
}
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { class: "formula-col" }
const _hoisted_26 = {
  key: 0,
  class: "formula-error-row"
}
const _hoisted_27 = {
  key: 1,
  class: "formula-field-header"
}
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "formula-block" }
const _hoisted_30 = {
  type: "submit",
  class: "button",
  "data-at": "button"
}
const _hoisted_31 = { class: "payment-methods" }
const _hoisted_32 = {
  key: 1,
  class: "viabill-section"
}
const _hoisted_33 = {
  key: 3,
  class: "apps"
}
const _hoisted_34 = { class: "app-item" }
const _hoisted_35 = ["href"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "bottom-part text-center" }
const _hoisted_38 = { class: "bottom-info" }
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 2,
  class: "menu-item-link"
}
const _hoisted_41 = { class: "sub-bottom-info" }
const _hoisted_42 = ["href"]
const _hoisted_43 = {
  key: 2,
  class: "menu-item-link"
}

import axios from "axios";
import { computed, defineAsyncComponent, onMounted, ref } from "vue";
import {
    applyUniqueKeyToObject,
    ensureUniqueKey,
} from "../../../shared/unique-identifier-key";
import {
    getPaymentMethodLogos,
    getViaBillLogo,
} from "../../controls/checkout/payment-type/image-urls";
import {
    type PaymentLogoKey,
    type PaymentMethodKey,
} from "../../controls/checkout/payment-type/payment-method";
import PaymentCardItem from "../../controls/frontend-productpage/shop/PaymentCardItem.vue";
import { type TrustpilotData } from "../../controls/header/top-site/trustpilot-data";
import Filler from "../../controls/shared/Filler.vue";
import { type IconKey } from "./async-icons";
import IconComponent from "./icon.vue";
import PaymentImage from "../../controls/checkout/shop-checkout/payment-image.vue";
type MenuItem = {
    href: string;
    target: string | undefined | null;
    text: string;
    items?: MenuItem[] | null | undefined;
};

type FooterData = {
    followHeader: string;
    leftPartContent: string;
    menuItemsHeader: string;
    menuItems: MenuItem[];
    menuItems2: MenuItem[];
    menuItems3: MenuItem[];
    apps: {
        image: string;
        link: string;
    }[];
    followLinks: {
        name: string;
        link: string;
        icon: IconKey;
    }[];
    formula?:
        | null
        | undefined
        | {
              header: string;
              subText: string;
              name: string;
              namePlaceholder: string | undefined | null;
              email: string;
              emailPlaceholder: string | undefined | null;
              submitText: string;
          };
    trustpilot?: TrustpilotData | undefined;
};

type FillerItemWithType = { type: "filler" };
type MenuItemWithType = MenuItem & { type: "menu-item" };
type MenuItemsItem = FillerItemWithType | MenuItemWithType;

type GroupItem = {
    header?: string | null | undefined;
    items: MenuItemsItem[];
};

type ErrorData = {
    errorField?: string;
    reason?: string;
};

type SubResult =
    | {
          success: true;
          message: string;
      }
    | ({
          success: false;
      } & ErrorData);


export default /*@__PURE__*/_defineComponent({
  __name: 'footer-comp',
  setup(__props) {

const trustpilotBanner = defineAsyncComponent(
    () =>
        import("../../controls/header/trustpilot-banner/trustpilot-banner.vue")
);

const paymentKeys = ref<(PaymentLogoKey | PaymentMethodKey)[]>([
    "CreditCard",
    "MobilePay",
    "PayEx",
    "visa",
    "mastercard",
    "dankort",
]);

const cardPaymentLogos = computed(() => {
    return getPaymentMethodLogos(paymentKeys.value);
});

const footerDataRequest = axios
    .create({
        adapter: "fetch",
        fetchOptions: {
            priority: "low",
        },
    })
    .get<FooterData>("/api/footer", {
        params: {
            v: window.odendo.staticFileVersion,
        },
    });

const data = ref<FooterData | null>(null);

function* flatten<T>(
    arr: T[],
    selector: (item: T) => T[] | undefined | null
): Generator<T> {
    for (const item of arr) {
        yield item;
        const subItems = selector(item);
        if (subItems != null) {
            for (const subItem of flatten(subItems, selector)) {
                yield subItem;
            }
        }
    }
}

onMounted(async () => {
    const newData = (await footerDataRequest).data;
    data.value = newData;
    for (const item of flatten(newData.menuItems, (x) => x.items)) {
        Object.assign(applyUniqueKeyToObject(item), { type: "menu-item" });
    }
    menuItems.value = newData.menuItems as MenuItemWithType[];
});

function* repeat<T>(v: T, count: number, copy = false) {
    for (let i = 0; i < count; i++) {
        if (copy) {
            yield structuredClone(v);
        } else {
            yield v;
        }
    }
}

const menuItems = ref<MenuItemsItem[]>(
    Array.from(repeat({ type: "filler" } as FillerItemWithType, 10, true)).map(
        applyUniqueKeyToObject
    )
);

const navItemGroups = computed(() => {
    if (
        menuItems.value.some(
            (x) =>
                x.type == "filler" ||
                (x.href != null && x.href.trim().length > 0)
        )
    ) {
        return [
            applyUniqueKeyToObject({
                header: data.value?.menuItemsHeader,
                items: menuItems.value,
            } as GroupItem),
        ];
    }
    const result: GroupItem[] = [];
    for (const groupMenu of menuItems.value) {
        if (groupMenu.type == "filler") {
            continue;
        }
        if (groupMenu.items == null) continue;
        result.push(
            applyUniqueKeyToObject({
                header: groupMenu.text,
                items: groupMenu.items,
            } as GroupItem)
        );
    }
    return result;
});

const formulaLoading = ref(false);

const name = ref("");
const email = ref("");

const formulaError = ref<ErrorData | null>(null);
const formulaSet = ref(false);
const formulaHeight = ref(0);
const formulaReply = ref("");

async function submitFormula(event: Event) {
    if (!(event instanceof SubmitEvent)) return;
    if (formulaLoading.value == true) return;
    formulaLoading.value = true;
    try {
        formulaError.value = null;
        const form =
            event.target != null
                ? event.target instanceof HTMLFormElement
                    ? event.target
                    : "form" in event.target
                    ? (event.target.form as HTMLFormElement)
                    : undefined
                : undefined;
        if (form == null) throw new Error("Form error");
        const action = form.action;
        const method = form.method;
        if (method.toLowerCase() != "post") throw new Error("Form error");
        const response = await axios.post<SubResult>(action, {
            name: name.value,
            email: email.value,
        });
        const result = response.data;
        if (!result.success) {
            formulaError.value = result;
        } else {
            formulaHeight.value = form.offsetHeight;
            formulaSet.value = true;
            if (result.message != null && result.message != "") {
                formulaReply.value = result.message;
            }
        }
    } catch (e) {
    } finally {
        formulaLoading.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (data.value == null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(Filler, {
                  min: 150,
                  max: 200
                }),
                _cache[3] || (_cache[3] = _createTextVNode("   ")),
                _createVNode(Filler, {
                  min: 80,
                  max: 120
                }),
                _cache[4] || (_cache[4] = _createTextVNode("   ")),
                _createVNode(Filler, {
                  min: 150,
                  max: 190
                })
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: data.value.leftPartContent
              }, null, 8 /* PROPS */, _hoisted_5))
        ]),
        (data.value != null && data.value.followLinks.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(data.value.followHeader), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.followLinks, (followLink) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "follow-icon",
                    "aria-label": 'Følg os på ' + followLink.name,
                    href: followLink.link,
                    target: "_blank"
                  }, [
                    _createVNode(IconComponent, {
                      class: "icon-comp",
                      value: followLink.icon,
                      color: "white"
                    }, null, 8 /* PROPS */, ["value"])
                  ], 8 /* PROPS */, _hoisted_9))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("nav", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItemGroups.value, (navItemGroup) => {
            return (_openBlock(), _createElementBlock("ol", {
              class: "footer-items",
              key: _unref(ensureUniqueKey)(navItemGroup)
            }, [
              (navItemGroup.header != null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString(navItemGroup.header), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItemGroup.items, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: _unref(ensureUniqueKey)(item)
                }, [
                  _createElementVNode("a", {
                    href: item.type === 'filler' ? '#' : item.href,
                    target: 
                                    item.type == 'menu-item' &&
                                    item.target != null
                                        ? item.target
                                        : ''
                                
                  }, [
                    (item.type === 'filler')
                      ? (_openBlock(), _createBlock(Filler, {
                          key: 0,
                          min: 10,
                          max: 20
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_13)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({
                    'formula-part': true,
                    'formula-part--sent': formulaSet.value,
                })
      }, [
        (formulaSet.value != true)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "formula",
              action: "/api/footer/subscribe-newsletter",
              method: "post",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submitFormula($event)), ["prevent"]))
            }, [
              (
                            formulaError.value != null &&
                            formulaError.value.errorField == null &&
                            formulaError.value.reason != null
                        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(formulaError.value?.reason), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (data.value == null || data.value.formula != null)
                ? (_openBlock(), _createElementBlock("fieldset", {
                    key: 1,
                    disable: formulaLoading.value
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, [
                            (data.value == null)
                              ? (_openBlock(), _createBlock(Filler, {
                                  key: 0,
                                  min: 23,
                                  max: 23
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(data.value.formula?.header), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, [
                          (data.value == null)
                            ? (_openBlock(), _createBlock(Filler, {
                                key: 0,
                                min: 69,
                                max: 69
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(data.value.formula?.subText), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        (
                                        formulaError.value != null &&
                                        formulaError.value.errorField == 'name' &&
                                        formulaError.value.reason != null
                                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(formulaError.value?.reason), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (data.value?.formula?.name != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(data.value.formula.name), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          autocomplete: "name",
                          id: "formula-field-name",
                          required: "",
                          class: _normalizeClass({
                                        'text-field': true,
                                        'text-field-error':
                                            formulaError.value?.errorField == 'name',
                                    }),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                          placeholder: 
                                        data.value?.formula?.namePlaceholder ??
                                        undefined
                                    
                        }, null, 10 /* CLASS, PROPS */, _hoisted_24), [
                          [_vModelText, name.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        (
                                        formulaError.value != null &&
                                        formulaError.value.errorField == 'email' &&
                                        formulaError.value.reason != null
                                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(formulaError.value?.reason), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (data.value?.formula?.email != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(data.value.formula.email), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          autocomplete: "email",
                          id: "formula-field-email",
                          required: "",
                          class: _normalizeClass({
                                        'text-field': true,
                                        'text-field-error':
                                            formulaError.value?.errorField == 'email',
                                    }),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
                          placeholder: 
                                        data.value?.formula?.emailPlaceholder ??
                                        undefined
                                    
                        }, null, 10 /* CLASS, PROPS */, _hoisted_28), [
                          [_vModelText, email.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("button", _hoisted_30, _toDisplayString(data.value?.formula?.submitText), 1 /* TEXT */)
                    ])
                  ], 8 /* PROPS */, _hoisted_15))
                : _createCommentVNode("v-if", true)
            ], 32 /* NEED_HYDRATION */))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "filler-formula-sent",
              style: _normalizeStyle({
                        height:
                            formulaHeight.value > 0
                                ? `${formulaHeight.value}px`
                                : undefined,
                    })
            }, _toDisplayString(formulaReply.value), 5 /* TEXT, STYLE */)),
        _createElementVNode("div", _hoisted_31, [
          (cardPaymentLogos.value != null)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cardPaymentLogos.value, (cardPaymentLogo) => {
                return (_openBlock(), _createBlock(PaymentCardItem, {
                  "card-payment-logo": cardPaymentLogo,
                  lazy: ""
                }, null, 8 /* PROPS */, ["card-payment-logo"]))
              }), 256 /* UNKEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (paymentKeys.value?.includes('PayEx') == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(PaymentImage, {
                  "image-data": _unref(getViaBillLogo)(),
                  lazy: "",
                  alt: "ViaBill logo"
                }, null, 8 /* PROPS */, ["image-data"])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (data.value?.trustpilot)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
              _createVNode(_unref(trustpilotBanner), {
                "model-value": data.value.trustpilot,
                "inverted-colors": ""
              }, null, 8 /* PROPS */, ["model-value"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (data.value != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.apps, (app) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("a", {
                    href: app.link,
                    class: "app-link",
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      class: "app-image",
                      alt: "",
                      src: app.image
                    }, null, 8 /* PROPS */, _hoisted_36)
                  ], 8 /* PROPS */, _hoisted_35)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _createElementVNode("section", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        (data.value != null)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.value.menuItems2.map(
                            (item, i) => ({ item, i })
                        ), ({ item, i }) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (i > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" - ")
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (item.href != null && item.href.trim() != '')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "menu-item-link",
                      href: item.href
                    }, _toDisplayString(item.text), 9 /* TEXT, PROPS */, _hoisted_39))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(item.text), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_41, [
        (data.value != null)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.value.menuItems3.map(
                            (item, i) => ({ item, i })
                        ), ({ item, i }) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (i > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" - ")
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (item.href != null && item.href.trim() != '')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "menu-item-link",
                      href: item.href
                    }, _toDisplayString(item.text), 9 /* TEXT, PROPS */, _hoisted_42))
                  : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(item.text), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})